"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateHeaderMenuItems = void 0;
var tslib_1 = require("tslib");
/**
 * @internal
 */
function activateHeaderMenuItems(items, ids) {
    return items.map(function (headerMenuList) {
        return headerMenuList.map(function (item) { return (tslib_1.__assign(tslib_1.__assign({}, item), { isActive: ids.indexOf(item.key) >= 0 })); });
    });
}
exports.activateHeaderMenuItems = activateHeaderMenuItems;
//# sourceMappingURL=activateHeaderMenuItems.js.map